/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { authCustomerState } from "./auth-customer.state";


const authCustomerSlice = createSlice({
    name: "authCustomer",

    initialState: authCustomerState,

    reducers: {
        setAuthenticated (state, action) {
            const authenticated = action.payload;
            state.authenticated = authenticated;
        },

        setUser (state, action) {
            const user = action.payload;
            state.user = user;
        },

    },
});

export const authCustomerReducer = authCustomerSlice.reducer;

export const {
    setAuthenticated,
    setUser,
} = authCustomerSlice.actions;
